import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Button, Icon, Form, Input, TreeSelect, Select, DatePicker, Checkbox } from '@h3/antd-vue';
import formPc from '../../../../../../form/src/renderer/components/pc';
import WorkflowTree from './tree_new.vue';
import * as utils from '../../../../../../common/src/utils/pc/utils';
let QueryWorkitem = class QueryWorkitem extends Vue {
    constructor() {
        super(...arguments);
        this.params = {
            sourceType: 'portal'
        }; // 关联组织介入之后需要过滤
        this.collapsed = true;
        this.daily = false;
        this.org = [];
        this.orgTree = [];
        // 选人控件已选人员、部门集合
        this.selectedValue = [];
        // 展示选人控件弹窗
        this.showSelector = false;
        // 是否关闭流程模板下拉列表
        this.closeWorkflowTree = false;
        this.scrollTop = 0;
        // 子流程模板
        this.workflowCode = '';
        this.staffSelectorOpts = {
            selectOrg: true,
            selectUser: true,
            mulpitle: false,
            showModel: true,
            showSelect: true,
            placeholder: '请选择'
        };
        // 表格数据
        this.queryData = {
            workflowName: '',
            originator: '',
            time: [],
            startTime: '',
            endTime: '',
            instanceState: '',
            activityName: '',
            participant: '',
            sequenceNo: '',
            participantName: '',
            participantId: '',
            toDoTaskTime: '',
            //二开 代理筛选条件
            trusteeName: '',
            startDate: '',
            endDate: '',
            //二开 结束
            crossOriginator: '' // 跨entity申请人
        };
        this.showMore = false;
        this.workflowName = {};
        //二开queryform筛选条件
        this.isShowflowTemplate = true;
    }
    // 二开结束
    mounted() {
        this.placeHolderLang();
        setTimeout(() => {
            if (localStorage.getItem('temp')) {
                let tempArr = JSON.parse(localStorage.getItem('temp') || '[]');
                tempArr.forEach(item => {
                    if (item.id === this.$store.state.System.System.loginedUserInfo.id) {
                        this.queryData = item.d;
                    }
                });
                return;
            }
            else if (localStorage.getItem('daily')) {
                let dailyArr = JSON.parse(localStorage.getItem('daily') || '[]');
                dailyArr.forEach(item => {
                    if (item.id === this.$store.state.System.System.loginedUserInfo.id) {
                        this.queryData = item.d;
                    }
                });
            }
        }, 500);
        console.log(this.queryData);
        const queryLeftDom = this.$refs.queryFormLeft;
        const containerWidth = queryLeftDom.clientWidth;
        let arr = [];
        //TODO 不知是哪位开的头，后期需要优化
        if (this.isShowInstanceState && this.isShowOriginator) { // 展示流程状态，就会有5个
            arr = ['1', '2', '3', '4', '5'];
        }
        else if (this.isShowInstanceState) {
            arr = ['1', '2', '3', '5'];
        }
        else if (this.isShowOriginator && this.isShowTimeRange) {
            arr = ['1', '3', '4', '5'];
        }
        else if (this.isShowOriginator && !this.isShowTimeRange) {
            arr = ['1', '3', '4'];
        }
        else {
            arr = ['1', '3', '5'];
        }
        let itemsWidth = 0;
        arr.forEach((item) => {
            const _key = `queryForm${item}`;
            const _dom = this.$refs[_key];
            itemsWidth += _dom.$el.clientWidth + 16;
        });
        if (itemsWidth >= containerWidth) {
            this.showMore = true;
        }
        else {
            this.showMore = false;
        }
        //二开queryform筛选条件
        if (this.$route.name === 'myUnfinishedWorkItem' || this.$route.name === 'myFinishedWorkItem' || this.$route.name === 'myWorkflow') {
            this.isShowflowTemplate = false;
        }
        // 二开结束
    }
    // {name, name_i18n}
    onSelect(nameObj) {
        this.workflowName = nameObj;
    }
    onChange(e) {
        if (e.target.checked) {
            this.daily = true;
        }
    }
    onScroll(e) {
        this.scrollTop = e && e.target && e.target.scrollTop;
    }
    toggle() {
        this.collapsed = !this.collapsed;
    }
    formatData() {
        const obj = {
            workflowName: this.queryData.workflowName,
            workflowCode: this.workflowCode ? this.workflowCode.split('-')[1] : '',
            originator: (this.queryData.originator && this.queryData.originator[0]) ? this.queryData.originator[0].id : '',
            unitType: (this.queryData.originator && this.queryData.originator[0]) ? this.queryData.originator[0].unitType : '',
            startTime: (this.queryData.time && this.queryData.time.length > 0) ? utils.timeStampToDate('YY-MM-DD', this.queryData.time[0]._d) : (this.queryData.toDoTaskTime ? utils.timeStampToDate('YY-MM-DD', this.queryData.toDoTaskTime._d) : ''),
            endTime: (this.queryData.time && this.queryData.time.length > 0) ? utils.timeStampToDate('YY-MM-DD', this.queryData.time[1]._d) : '',
            instanceState: this.queryData.instanceState,
            originatorName: (this.queryData.originator && this.queryData.originator[0]) ? this.queryData.originator[0].name : '',
            workflowTplName: this.workflowCode ? this.workflowName : '',
            activityName: this.queryData.activityName,
            participant: (this.queryData.participant && this.queryData.participant[0]) ? this.queryData.participant[0].id : '',
            participantName: (this.queryData.participant && this.queryData.participant[0]) ? this.queryData.participant[0].name : '',
            participantId: (this.queryData.participantId && this.queryData.participantId[0]) ? this.queryData.participantId[0].id + '_$$_' + this.queryData.participantId[0].name : '',
            participantUnitType: (this.queryData.participant && this.queryData.participant[0]) ? this.queryData.participant[0].unitType : '',
            sequenceNo: this.queryData.sequenceNo,
            trusteeName: this.queryData.trusteeName,
            startDate: this.queryData.startDate ? utils.timeStampToDate('YY-MM-DD', this.queryData.startDate._d) : '',
            endDate: this.queryData.endDate ? utils.timeStampToDate('YY-MM-DD', this.queryData.endDate._d) : '',
            crossOriginator: this.queryData.crossOriginator
        };
        if (!this.isShowInstanceState) {
            delete obj.instanceState;
        }
        if (!this.isShowOriginator) {
            delete obj.originator;
        }
        if (!this.isShowCurResolver) {
            delete obj.participant;
        }
        return obj;
    }
    resetFields() {
        this.queryData = {
            workflowName: '',
            time: [],
            startTime: '',
            endTime: '',
            originator: [],
            activityName: '',
            participant: [],
            instanceState: '',
            participantName: '',
            participantId: '',
            toDoTaskTime: '',
            // 二开 代理筛选
            trusteeName: '',
            startDate: '',
            endDate: '',
            // 二开结束
            crossOriginator: ''
        };
        this.workflowCode = ''; // 流程模板
    }
    reset() {
        this.collapsed = true;
        const d = this.formatData();
        // const isEmit:boolean = Object.values(d).some((item:any) => item !== '');
        const isEmit = true;
        if (isEmit) {
            this.$emit('reset', d);
            this.resetFields();
        }
    }
    search() {
        const d = this.formatData();
        console.log(this.$store.state.System.System.loginedUserInfo);
        // const newData = {d, id: this.$store.state.System.System.loginedUserInfo.id}
        // if(this.daily) {
        //   let dailyArr = localStorage.getItem('daily') ? JSON.parse(localStorage.getItem('daily') || '[]') : []
        //   const index = dailyArr.findIndex(item => item.id === this.$store.state.System.System.loginedUserInfo.id)
        //   index >= 0 ? dailyArr[index] = newData : dailyArr.push(newData)
        //   localStorage.setItem('daily', JSON.stringify(dailyArr))
        // }else {
        //   let tempArr = localStorage.getItem('temp') ? JSON.parse(localStorage.getItem('temp') || '[]') : []
        //   const index = tempArr.findIndex(item => item.id === this.$store.state.System.System.loginedUserInfo.id)
        //   index >= 0 ? tempArr[index] = newData : tempArr.push(newData)
        //   localStorage.setItem('temp', JSON.stringify(tempArr))
        // }
        this.$emit('search', d);
        this.collapsed = true;
    }
    /**
     * 选人控件placeholder多语言
     */
    placeHolderLang() {
        this.staffSelectorOpts.placeholder = this.$t('cloudpivot.flowCenter.pc.plzSelect');
    }
    closeQueryItem() {
        this.$emit('hide');
    }
    onLanguageChange(l) {
        this.placeHolderLang();
    }
    onIsResetFieldsChange(v) {
        if (v) {
            this.resetFields();
            this.collapsed = true;
        }
    }
};
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "isShowInstanceState", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "isShowOriginator", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "isShowCurResolver", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "timeLable", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], QueryWorkitem.prototype, "isShowTimeRange", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isWorkflowDelegation", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "isResetFields", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowSequenceNo", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowActivityName", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowParticipant", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowParticipantId", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowWorkFlowNode", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "hasTabs", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], QueryWorkitem.prototype, "isShowStartTime", void 0);
tslib_1.__decorate([
    Watch('$i18n.locale')
], QueryWorkitem.prototype, "onLanguageChange", null);
tslib_1.__decorate([
    Watch('isResetFields')
], QueryWorkitem.prototype, "onIsResetFieldsChange", null);
QueryWorkitem = tslib_1.__decorate([
    Component({
        name: 'query-workitem',
        components: {
            AButton: Button,
            AIcon: Icon,
            AInput: Input,
            AForm: Form,
            AFormItem: Form.Item,
            ATreeSelect: TreeSelect,
            ASelect: Select,
            ACheckbox: Checkbox,
            ASelectOption: Select.Option,
            ADatePicker: DatePicker,
            ARangePicker: DatePicker.RangePicker,
            // StaffSelector: renderer.components.pc.StaffSelector,
            StaffSelector: formPc.StaffSelector,
            WorkflowTree
        }
    })
], QueryWorkitem);
export default QueryWorkitem;
